module.exports = __webpack_public_path__ + "img/reserve.b945ad8c.png";